import React, { useEffect, useRef, useState } from 'react';
import logo from '../logo.svg';
import { MenuComponent } from './menu';
import { Link } from 'react-router-dom';

const useOutsideClick = (ref, callback) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
};

export interface MainMenuProps {
}

export const MainMenuComponent: React.FC<MainMenuProps> = () => {
  const [menuVisible, setMenuVisible] = useState(false);
  const menuRef = useRef(null);

  useOutsideClick(menuRef, () => setMenuVisible(false));

  const toggleMenu = () => {
    setMenuVisible((prev) => !prev);
  };

  const menuItems = [
    { icon: 'dff', text: 'Duplicate file finder', href: '/dff'},
    { icon: 'space-usage', text: 'Space usage', href: '/space-usage'},
    { icon: 'pdf', text: 'PDF Tool', href: '/pdf-tool'},
    { icon: 'eff', text: 'Empty folder finder', href: '/eff'},
    { divider: true },
    { icon: 'sign-out', text: 'Sign out', href: '/logout'},
  ];

  return (
    <>
      <img src={logo} alt="Koofr EXP logo" className="l-toolbar__logo" onClick={toggleMenu}/>
      { menuVisible &&
        <div ref={menuRef}>
          <MenuComponent right={10} y={60}>
            {menuItems.map((i, idx) => {
              if (i.icon === 'sign-out')
                return <div key={idx} className="menu__item">
                  <a href={i.href}>
                    <button className="menu__button">
                      <div className="menu__button-content">
                        <div className={`menu__icon menu__icon-${i.icon}`}></div>
                        <div className="menu__text">
                          {i.text}
                        </div>
                      </div>
                    </button>
                  </a>
                </div>;
              if (!i.divider)
                return <div key={idx} className="menu__item">
                  <Link to={i.href}>
                    <button className="menu__button">
                      <div className="menu__button-content">
                        <div className={`menu__icon menu__icon-${i.icon}`}></div>
                        <div className="menu__text">
                          {i.text}
                        </div>
                      </div>
                    </button>
                  </Link>
                </div>;
              else
                return <div key={idx} className="menu__divider"></div>;
            }
            )}
          </MenuComponent>
        </div>
      }
    </>
  );
};